import { Navigate } from 'react-router-dom';
import { useRoleCheck } from '@/app/hooks/useRoleCheck';

const RoleBasedRedirect = () => {
  const isCompanyOwner = useRoleCheck(['Company Owner']);

  if (isCompanyOwner) {
    return <Navigate to='/company-summary' />;
  }

  return <Navigate to='/orders' />;
};

export default RoleBasedRedirect;
